import { ApplicationConfig } from '@angular/core';
import { importProvidersFrom } from '@angular/core';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { TranslateStore, TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { provideState } from '@ngrx/store';
import { ColorThemeReducers } from '../store/color-theme/reducers';
import { ActiveLanguageReducers } from '../store/language/reducers';
import { provideEffects } from '@ngrx/effects';
import { JobsReducers } from '../store/jobs/reducers';
import { ProfileReducers } from '../store/profile/reducers';
import { HomeReducers } from '../store/home/reducers';
import { SettingsReducers } from '../store/settings/reducers';
import { NotificationsReducers } from '../store/notifications/reducers';
import { UnseenNotificationsReducers } from '../store/unseen-notifications/reducers';
import { BookmarkedNotificationsEffect } from '../store/bookmarked-notifications/effects';
import { NotificationsEffect } from '../store/notifications/effects';
import { HomeDataEffect } from '../store/home/effects';
import { JobsDataEffect } from '../store/jobs/effects';
import { ProfileDataEffect } from '../store/profile/effects';
import { SettingsDataEffect } from '../store/settings/effects';
import { provideIcons } from '@ng-icons/core';
import {
  bootstrapArrowClockwise,
  bootstrapBoxArrowInRight,
  bootstrapBriefcase,
  bootstrapBriefcaseFill,
  bootstrapCalendar2Event,
  bootstrapChatRightText,
  bootstrapCheck2,
  bootstrapCircleFill,
  bootstrapEnvelopeOpen,
  bootstrapFiletypePdf,
  bootstrapGear,
  bootstrapGeoAltFill,
  bootstrapGlobe2,
  bootstrapGrid,
  bootstrapHeart,
  bootstrapHeartFill,
  bootstrapHouse,
  bootstrapInfoCircle,
  bootstrapMoonFill,
  bootstrapPencil,
  bootstrapPerson,
  bootstrapPersonCircle,
  bootstrapSearch,
  bootstrapStar,
  bootstrapStarFill,
  bootstrapSunFill,
  bootstrapTrash,
  bootstrapPlus,
  bootstrapCardHeading,
  bootstrapChevronDown,
  bootstrapList,
  bootstrapCheckCircleFill,
  bootstrapCloudUpload,
  bootstrapXCircleFill,
  bootstrapEye,
} from '@ng-icons/bootstrap-icons';
import {
  heroBars3,
  heroPencilSquare,
  heroXMark,
  heroBanknotes,
} from '@ng-icons/heroicons/outline';
import {
  heroMinusCircleSolid
} from '@ng-icons/heroicons/solid';
import { provideAnimations, provideNoopAnimations } from '@angular/platform-browser/animations';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';




export const dashboardConfig: ApplicationConfig = {
  providers: [
    provideState("colorTheme", ColorThemeReducers),
    provideState("activeLanguage", ActiveLanguageReducers),
    provideState("jobFavoritesData", JobsReducers),
    provideState("profileData", ProfileReducers),
    provideState("homeData", HomeReducers),
    provideState("jobsData", JobsReducers),
    provideState("settingsData", SettingsReducers),
    provideState("notificationData", NotificationsReducers),
    provideState("unseenNotificationsData", UnseenNotificationsReducers),
    provideEffects([NotificationsEffect,HomeDataEffect,JobsDataEffect,ProfileDataEffect,SettingsDataEffect]),
    importProvidersFrom(
      ReactiveFormsModule,
      HttpClientModule,
      TranslateModule.forChild({
        loader: {
          provide: TranslateLoader,
          useFactory: httpLoaderFactory,
          deps: [HttpClient],
        },
      })),
    TranslateStore,
    provideIcons({
      bootstrapSunFill,
      bootstrapMoonFill,
      bootstrapHouse,
      bootstrapChatRightText,
      bootstrapBriefcase,
      bootstrapPerson,
      bootstrapGear,
      bootstrapBoxArrowInRight,
      bootstrapPencil,
      bootstrapFiletypePdf,
      bootstrapPersonCircle,
      bootstrapCalendar2Event,
      bootstrapGeoAltFill,
      bootstrapBriefcaseFill,
      bootstrapTrash,
      bootstrapGrid,
      bootstrapGlobe2,
      bootstrapHeart,
      bootstrapHeartFill,
      bootstrapSearch,
      bootstrapCircleFill,
      bootstrapInfoCircle,
      bootstrapCheck2,
      bootstrapEnvelopeOpen,
      bootstrapArrowClockwise,
      bootstrapStar,
      bootstrapStarFill,
      bootstrapPlus,
      bootstrapCardHeading,
      bootstrapChevronDown,
      bootstrapList,
      bootstrapCheckCircleFill,
      bootstrapCloudUpload,
      bootstrapXCircleFill,
      bootstrapEye,
      heroBars3,
      heroXMark,
      heroPencilSquare,
      heroMinusCircleSolid,
      heroBanknotes
    }),
  ]
};

export function httpLoaderFactory(_http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(_http, './assets/i18n/dashboard/dashboard-', '.json');
}
